
 import { authenticatedFetch } from "../Auth/Auth";
 import { getCurrentConfig } from '../../config/config';
 
 const config = getCurrentConfig();

export const getSuburbs = async (stateId,stateName) => {
   

 
    const response = await authenticatedFetch(`${config.API_BASE_URL}/suburbs`, {
        method: 'POST',
        headers: {
        
          'Content-Type': 'application/json',
          'User-Agent': 'agentApp/1.0',
        },
        body: JSON.stringify({stateId:stateId,state:stateName})
      });
      
      if (response.ok) {
        const responseData = await response.json();
        return responseData;
      } else {
        throw new Error(`Error getting suburbs`);
      }




};